import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { RHFSelect } from '@/shared/components/HookForm'
import { Skeleton } from '@/shared/components/ui/skeleton'
import { TableCell, TableRow } from '@/shared/components/ui/table'

import { useScenarioOptions } from '../lib/useScnerioOptions'

type OptimizationGroupsItemProps = {
	id: string
	name: string
}

export const OptimizationGroupsItem = ({
	id,
	name,
}: OptimizationGroupsItemProps) => {
	const { options, isLoading, optimizationGroupName, defaultValue } =
		useScenarioOptions(id)
	const { getValues, setValue } = useFormContext()

	useEffect(() => {
		if (defaultValue && !isLoading) {
			const currentValue = getValues(name)
			if (!currentValue) {
				setValue(name, defaultValue, { shouldDirty: true })
			}
		}
	}, [defaultValue, isLoading, name, getValues, setValue])

	if (isLoading) {
		return (
			<TableRow>
				<TableCell colSpan={2} className='h-9'>
					<Skeleton className='h-9 w-full' />
				</TableCell>
			</TableRow>
		)
	}

	return (
		<TableRow>
			<TableCell className='bg-muted/50 font-medium'>
				{optimizationGroupName}
			</TableCell>
			<TableCell className='w-52 text-left'>
				<RHFSelect
					isLoading={isLoading}
					name={name}
					options={options}
					defaultValue={defaultValue}
					className='w-full truncate'
				/>
			</TableCell>
		</TableRow>
	)
}
